export class ColoresFilter {
    color
    filterType = 'colores'
    constructor(color) {
        this.color = color
    }

    apply(products) {
        return products.filter(product => {
            return (product.Color.toLowerCase() === this.color.nombre.toLowerCase())
        })
    }
}